// 'use server'
import { getServerSession } from '@actions/get-session';

import { mCubeRepository } from '@repositories/mcube';

import { ForbiddenUserType, UserType, UserTypeEnum } from '@app-types/user';

export const getImpactSimulationServer = async (gencodes: string[]) => {
    const session = await getServerSession();
    const user = session?.user as UserType | undefined;

    if (user && !ForbiddenUserType.includes(user.user_type as UserTypeEnum)) {
        return mCubeRepository.getImpactSimulationByPerson(user, gencodes);
    }

    return null;
};
